import { z } from 'zod'

import { randomManagedDocSlug } from '@scalar-org/random-slug'

import {
  entitySchema,
  namespaceSchema,
  nanoidSchema,
  scalarSet,
  slugSchema,
} from '@/utility'

export const registryPathRegex = () =>
  /^([a-z0-9_-]+)\/(apis|rules|schemas|sdks)\/([a-z0-9_-]+)$/

export enum RegistryAsset {
  Apis = 'apis',
  Rules = 'rules',
  Schemas = 'schemas',
  Sdks = 'sdks',
  Workspaces = 'workspaces',
}

export const RegistryResourceTypes = [
  RegistryAsset.Apis,
  RegistryAsset.Schemas,
  RegistryAsset.Rules,
  RegistryAsset.Sdks,
  RegistryAsset.Workspaces,
] as const

export type ResourceType = (typeof RegistryResourceTypes)[number]

export const registryAssetSchema = z
  .enum(RegistryAsset)
  .meta({ id: 'registry-asset' })

export const baseRegistrySchema = entitySchema
  .extend({
    /** Team namespace - not linked by UID */
    namespace: namespaceSchema,
    /** UI label for registry item */
    title: z.string().max(100).default(''),
    /** Unique configuration identifier */
    slug: slugSchema
      .default(randomManagedDocSlug)
      .meta({ default: 'randomManagedDocSlug()' }),
    /** Extended description for registry item */
    description: z.string().default(''),
    /** Public accessibility */
    isPrivate: z.boolean().default(false),
    /** Grouping/identifier tags */
    tags: scalarSet(z.set(z.string()).max(100)).default([]),
    /** Access groups for private access permissions */
    accessGroups: scalarSet(z.set(nanoidSchema).max(50)).default([]),
    /** The uid of the login portal customization object for private documents */
    loginPortalUid: z.string().optional(),
    /** Whether the content has been scanned and confirmed to not to contain malicious content */
    verifiedContent: z.boolean().optional(),
  })
  .meta({ id: 'base-registry' })

export type BaseRegistryRecord = z.infer<typeof baseRegistrySchema>
